import { BuildFontString } from "./BuildFontString";
import { enumFontIconWeights } from "../constants";
import { QFALabelButton } from "../CoreApp/QFALabelButton";
import { fontIconString } from "./fontIconString.js";

export function AddStdFALabelButton(parent, label, faIcon, cmdCode, x, y, labelSize, bold = false) {
  var fAWeight = bold ? enumFontIconWeights.bold : enumFontIconWeights.regular;
  var iconFontSize = labelSize ? labelSize + 1 : 13;
  var fAStyle = fontIconString(iconFontSize, fAWeight);
  var button = new QFALabelButton();
  button.fFontString = BuildFontString("Arial", labelSize ? labelSize : 12, bold === true);
  button.fLabelFontSize = labelSize;
  button.SetFAStyle(fAStyle);
  button.InitButton(parent, cmdCode, x, y, label, faIcon);
  button.AutoSize();
  return button;
}
